import * as Api from '@ViewModels';
import { useMemo, useState } from 'react';
import { PhoneNumberLabelDictionary, PhoneNumberLabels } from '../../../../../../../../models';
import { css } from '../../../../../../../../surveys/components/Modal/styles';
import { ISelectBoxOption, SelectBox } from '../../../../../../../components/SelectBox';
import { TextInput } from '../../../../../../../components/TextInput';
import { styleSheet } from '../../styles';

export const PhoneNumberForm = ({
	onChange,
	phone,
}: {
	phone: Api.IPhoneNumber;
	onChange: (value: Api.IPhoneNumber) => void;
}) => {
	const [newPhoneNumber, setNewPhoneNumber] = useState<Api.IPhoneNumber>(phone);

	const onPhoneNumberLabelChanged = (selectedOption: ISelectBoxOption<string>) => {
		setNewPhoneNumber({ ...newPhoneNumber, label: selectedOption.value });
		onChange({ ...newPhoneNumber, label: selectedOption.value } as Api.IPhoneNumber);
	};

	const onPhoneNumberValueChanged = (ev: React.ChangeEvent<HTMLInputElement>) => {
		setNewPhoneNumber({ ...newPhoneNumber, value: ev.target.value });
		onChange({ ...newPhoneNumber, value: ev.target.value } as Api.IPhoneNumber);
	};

	const labelOptions = useMemo(() => {
		const lowerLabel = newPhoneNumber.label?.toLowerCase();
		const hasDefaultLabel = !!lowerLabel && !!PhoneNumberLabelDictionary[lowerLabel];

		return hasDefaultLabel
			? [{ title: newPhoneNumber.label, value: lowerLabel }, ...PhoneNumberLabels]
			: PhoneNumberLabels;
	}, [newPhoneNumber.label]);

	return (
		<div className={css(styleSheet.phoneNumberFormContainer)}>
			<SelectBox
				onSelectionChanged={onPhoneNumberLabelChanged}
				options={labelOptions}
				placeholder={<span>Label...</span>}
				selectedOption={
					newPhoneNumber.label ? labelOptions.find(x => x.value === newPhoneNumber.label.toLowerCase()) : undefined
				}
				className={css(styleSheet.phoneNumberSelectBox)}
			/>

			<TextInput
				autoComplete='off'
				inputId='edit-entity-phone-number-input'
				value={newPhoneNumber.value}
				onChange={onPhoneNumberValueChanged}
				placeholder='Phone Number'
				type={'tel'}
				className={css(styleSheet.editInput)}
			/>
		</div>
	);
};
